<template>
  <div class="my-photos">
    <el-container class="common-container">
      <el-main class="main">
        <div class="title">
          <span>
            我的照片
          </span>
        </div>
        <div class="photos-upload">
          <el-upload
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            list-type="picture"
          >
            <el-button
              size="small"
              type="primary"
              class="up-button"
            >
              点击上传
            </el-button>
            <div
              slot="tip"
              class="el-upload__tip"
            >
              只能上传jpg/png文件，每张不超过2M，最多支持9张照片
            </div>
          </el-upload>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'MyPhotos',
  props: {
    formData: {
      type: Object,
      default: () => {
        return {
          pictureArr: [],
          isActive: true
        }
      }
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 文件列表
      fileList: []
    }
  },
  watch: {
    formData (newVal, oldVal) {
      this.fileList = this._.cloneDeep(newVal.pictureArr)
    }
  },
  methods: {
    handlePreview () {},
    handleRemove () {}
  }
}
</script>

<style lang="scss" scoped>
.my-photos {
  background-color: #fff;
  width: 100%;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .photos-upload {
    margin-top: 30px;

    // .up-button {
    //   position: absolute;
    // }
  }
}
</style>
